import { render, staticRenderFns } from "./ServiceAgreement.vue?vue&type=template&id=77a24c00&scoped=true&"
import script from "./ServiceAgreement.vue?vue&type=script&lang=js&"
export * from "./ServiceAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAgreement.vue?vue&type=style&index=0&id=77a24c00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a24c00",
  null
  
)

export default component.exports